/**
 * 구독 취소 모달
 * FSD: features/subscription/subscription-manage/ui
 */

import React, { useState } from 'react';

interface CancelModalProps {
  onCancel: (reason?: string) => Promise<void>;
  onClose: () => void;
}

export const CancelModal: React.FC<CancelModalProps> = ({ onCancel, onClose }) => {
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const handleSubmit = async () => {
    if (!confirmed) {
      alert('취소 확인을 체크해주세요');
      return;
    }

    setIsLoading(true);
    try {
      await onCancel(reason || undefined);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>구독 취소</h2>
          <button className="close-button" onClick={onClose} disabled={isLoading}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="warning-box">
            <p className="warning-text">
              ⚠️ 구독을 취소하면 영구적으로 구독이 종료되며, 복구할 수 없습니다.
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="reason">취소 사유</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="취소 사유를 입력해주세요"
              rows={3}
              disabled={isLoading}
            />
          </div>

          <div className="checkbox-group">
            <input
              id="confirm"
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              disabled={isLoading}
            />
            <label htmlFor="confirm">
              구독 취소에 동의합니다. 이 작업은 되돌릴 수 없습니다.
            </label>
          </div>
        </div>

        <div className="modal-footer">
          <button
            onClick={handleSubmit}
            disabled={isLoading || !confirmed}
            className="confirm-button danger"
          >
            {isLoading ? '처리 중...' : '취소'}
          </button>
          <button onClick={onClose} disabled={isLoading} className="cancel-button">
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
